import { render, staticRenderFns } from "./RegistroCollapse.vue?vue&type=template&id=1d6fea08&scoped=true&"
import script from "./RegistroCollapse.vue?vue&type=script&lang=js&"
export * from "./RegistroCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fea08",
  null
  
)

export default component.exports